// extracted by mini-css-extract-plugin
export default {"saveCardContainer":"W4Ss40Wt8LNBd9NGYWbw","defaultCardContainer":"Spmut4We8wEVSf1UJi06","dividerMargin":"gSizG2vx5kv1KbzB1fTi"};